import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
import Footer from "../Component/Footer";
const Mission = () => {
  useEffect(() => {
    document.title = "Mission -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> About Us </li>
          <li> Mission </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Mission </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/mision.jpeg"
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt=""
                  />
                </LazyLoad>
                <ul className="list">
                  <li>
                    To inculcate values in students so that we will have
                    socially, intellectually, emotionally, spiritually and
                    morally upright citizens.
                  </li>
                  <li>
                    To provide them with a conducive environment to infuse a
                    sense of responsibility, self -discipline and
                    integrity.{" "}
                  </li>
                  <li>
                    {" "}
                    To promote creative thinking of the students so that they
                    may excel in society and become capable to face challenges
                    in life.{" "}
                  </li>
                  <li>
                    {" "}
                    To love mother earth and to have an awakening of a new
                    conscience for sustaining the integrity of humanity and
                    creation.{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Mission;
